import { styled, css } from 'styled-components';
import { StateLayer as CoreStateLayer } from '../../core-components';
const SP_50 = 'var(--aui-spacing-050)';
const SP_100 = 'var(--aui-spacing-100)';
const SP_150 = 'var(--aui-spacing-150)';
const SP_200 = 'var(--aui-spacing-200)';
export const StateLayer = styled(CoreStateLayer).withConfig({
  componentId: "aui__sc-13c3q2e-0"
})(["border-radius:var(--aui-action-border-radius);"]);
export const LoadingContainer = styled.div.withConfig({
  componentId: "aui__sc-13c3q2e-1"
})(["position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);"]);
export const TextContainer = styled.span.withConfig({
  componentId: "aui__sc-13c3q2e-2"
})([""]);
export const StyledAction = styled.button.withConfig({
  componentId: "aui__sc-13c3q2e-3"
})(["all:unset;cursor:", ";user-select:none;font-size:", ";line-height:", ";padding:", ";border-radius:", ";box-sizing:border-box;position:relative;overflow:hidden;display:inline-flex;align-items:center;justify-content:center;gap:", ";color:", ";background:", ";border:", ";&:focus-visible{outline:revert;}", "{opacity:", ";text-decoration:", ";}[data-aui='icon']{opacity:", ";}", "{background:", ";opacity:", ";border:", ";}", ""], getCursor, getFontSize, getLineHeight, getPadding, getBorderRadius, getGap, getColor, getBackground, getBorder, TextContainer, getTextOpacity, getTextDecoration, getTextOpacity, StateLayer, getStateLayerBackground, getStateLayerOpacity, getStateLayerBorder, ({
  $state
}) => $state === 'enabled' && css(["&:hover{color:", ";", "{text-decoration:none;}", "{background-color:", ";opacity:", ";}}&:active{color:", ";box-shadow:", ";", "{opacity:", ";}}"], getInteractionColor, TextContainer, StateLayer, getHoverStateLayerBackground, getHoverStateLayerOpacity, getInteractionColor, getBoxShadow, StateLayer, getActiveStateLayerOpacity));
function getFontSize({
  $size
}) {
  if ($size === 'sm') {
    return '0.875rem';
  } else if ($size === 'md') {
    return '1rem';
  } else {
    return '1.25rem';
  }
}
function getLineHeight({
  $size
}) {
  if ($size === 'sm') {
    return 1.15;
  } else if ($size === 'md') {
    return 1.5;
  } else if ($size === 'lg') {
    return 1.6;
  }
}
function getPadding({
  $size,
  $variant,
  $iconVariant,
  $state
}) {
  let padding;
  const renderStyle = padding => padding.length > 1 ? `calc(${padding.join(' + ')})` : padding[0];
  if ($size === 'sm') {
    padding = {
      top: [SP_100],
      bottom: [SP_100],
      left: [SP_100],
      right: [SP_100]
    };
  } else if ($size === 'md') {
    padding = {
      top: [SP_150],
      bottom: [SP_150],
      left: [SP_100, SP_150],
      right: [SP_100, SP_150]
    };
  } else if ($size === 'lg') {
    padding = {
      top: [SP_200],
      bottom: [SP_200],
      left: [SP_150, SP_100],
      right: [SP_150, SP_100]
    };
  }
  if ($variant === 'outline' && $state === 'enabled') {
    padding.top.push('-1px');
    padding.bottom.push('-1px');
    padding.left.push('-1px');
    padding.right.push('-1px');
  }
  if ($iconVariant === 'only') {
    return renderStyle(padding.top);
  } else if ($iconVariant === 'left') {
    if ($size === 'sm') {
      padding.left.push(SP_50);
    }
    padding.right.push(SP_100);
  } else if ($iconVariant === 'right') {
    if ($size === 'sm') {
      padding.right.push(SP_50);
    }
    padding.left.push(SP_100);
  } else if ($iconVariant === 'none') {
    padding.left.push(SP_100);
    padding.right.push(SP_100);
  } else if ($size === 'sm') {
    padding.left.push(SP_50);
    padding.right.push(SP_50);
  }
  if ($variant === 'flat') {
    padding.left = ['0'];
    padding.right = ['0'];
  }
  return [padding.top, padding.right, padding.bottom, padding.left].map(renderStyle).join(' ');
}
function getTextDecoration({
  $variant,
  $iconVariant
}) {
  if ($variant === 'flat' && $iconVariant !== 'only') {
    return 'underline';
  }
}
function getGap({
  $size
}) {
  if ($size === 'sm') {
    return SP_50;
  } else if ($size === 'md' || $size === 'lg') {
    return SP_100;
  }
}
function getColor({
  $state,
  $variant
}) {
  if ($state !== 'enabled') {
    return 'var(--aui-action-on-surface)';
  } else if ($variant === 'filled') {
    return 'var(--aui-action-on-filled-action)';
  } else if ($variant === 'tonal') {
    return 'var(--aui-action-on-tonal-action)';
  } else if ($variant === 'outline') {
    return 'var(--aui-action-outline-action)';
  } else if ($variant === 'flat') {
    return 'var(--aui-action-on-surface)';
  }
}
function getBackground({
  $variant,
  $state
}) {
  if ($state === 'readonly' || $state === 'loading') {
    return 'var(--aui-surface)';
  } else if ($state === 'disabled') {
    if ($variant !== 'outline') {
      return 'unset';
    } else {
      return 'var(--aui-surface)';
    }
  } else if ($variant === 'filled') {
    return 'var(--aui-action-filled-action)';
  } else if ($variant === 'tonal') {
    return 'var(--aui-action-tonal-action)';
  } else if ($variant === 'outline') {
    return 'none';
  } else if ($variant === 'flat') {
    return 'none';
  }
}
function getBorder({
  $variant,
  $state
}) {
  if ($state === 'disabled') {
    return 'unset';
  } else if ($variant === 'outline' && $state !== 'readonly' && $state !== 'loading') {
    return '1px solid currentColor';
  }
}
function getBorderRadius({
  $iconVariant,
  $variant
}) {
  if ($variant === 'flat' && $iconVariant !== 'only') {
    return '0';
  }
  return 'var(--aui-action-border-radius)';
}
function getInteractionColor(props) {
  if (props.$variant === 'outline') {
    return 'var(--aui-action-subtle-engaged)';
  } else {
    return getColor(props);
  }
}
function getBoxShadow({
  $variant,
  $iconVariant
}) {
  if ($variant === 'flat' && $iconVariant !== 'only') {
    return 'none';
  } else {
    return '2px 2px 4px 4px var(--aui-fills-actions-pressed-shadow) inset';
  }
}
function getTextOpacity({
  $state
}) {
  if ($state === 'loading') {
    return 0;
  } else if ($state === 'readonly') return 'var(--aui-state-layer-on-read-only);';else if ($state === 'disabled') return 'var(--aui-state-layer-on-disabled);';
}
function getStateLayerBackground({
  $state,
  $variant,
  $iconVariant
}) {
  if ($state === 'disabled') {
    if ($variant === 'flat' && $iconVariant === 'only') {
      return 'unset';
    } else if ($variant !== 'outline') {
      return 'var(--aui-action-on-surface)';
    } else if ($variant === 'outline') {
      return 'unset';
    }
  }
  if (($state === 'readonly' || $state === 'loading') && ($variant === 'filled' || $variant === 'tonal')) return 'var(--aui-action-on-surface)';else if ($variant === 'outline') return 'unset';
}
function getStateLayerOpacity({
  $state,
  $variant,
  $iconVariant
}) {
  if ($variant === 'flat' && $iconVariant !== 'only') {
    return 0;
  } else if ($state === 'disabled') {
    return 'var(--aui-state-layer-disabled)';
  } else if ($state !== 'enabled' && ($variant === 'filled' || $variant === 'tonal')) {
    return 'var(--aui-state-layer-read-only)';
  } else if ($state !== 'enabled' && $variant === 'outline') {
    return 'var(--aui-state-layer-disabled)';
  }
}
function getActiveStateLayerOpacity({
  $variant,
  $iconVariant
}) {
  if ($variant === 'flat' && $iconVariant !== 'only') {
    return 0;
  } else {
    return 'var(--aui-state-layer-press)';
  }
}
function getHoverStateLayerOpacity({
  $variant,
  $iconVariant
}) {
  if ($variant === 'flat' && $iconVariant !== 'only') {
    return 0;
  } else {
    return 'var(--aui-state-layer-hover)';
  }
}
function getHoverStateLayerBackground(props) {
  if (props.$variant === 'outline') {
    return 'var(--aui-action-subtle-engaged)';
  } else {
    return getStateLayerBackground(props);
  }
}
function getStateLayerBorder({
  $state,
  $variant
}) {
  if (($state === 'readonly' || $state === 'disabled' || $state === 'loading') && $variant === 'outline') {
    return `1px solid var(--aui-action-on-surface)`;
  }
}
function getCursor({
  $state
}) {
  if ($state === 'disabled') {
    return 'not-allowed';
  } else {
    return 'pointer';
  }
}